import { defineComponent as _defineComponent } from 'vue'

import Icon from "../widgets/icons/Icon.vue"
import useRouter from "@/router/useRouter"


export default /*#__PURE__*/_defineComponent({
  __name: 'NavItem',
  props: {
  to: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: false,
  },
  rotate: {
    type: Number,
    required: false,
  },
},
  setup(__props) {

const { routes } = useRouter()



return { __sfc: true,routes, Icon }
}

})